module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Arrow-to-left-76c1c310cc84338275b30c88b14ed3cb.svg";